var map = {
	"./burger_icon.svg": 1113,
	"./camp.svg": 1350,
	"./creative.svg": 1351,
	"./cross.svg": 1114,
	"./earth_group.svg": 1352,
	"./feature_1.svg": 1353,
	"./feature_2.png": 1138,
	"./feature_2.svg": 1354,
	"./feature_3.svg": 1355,
	"./flag.svg": 1161,
	"./frontend.svg": 1356,
	"./gamedesign.svg": 1357,
	"./graphicdesign.svg": 1358,
	"./junior.svg": 1359,
	"./map_yellow.svg": 1160,
	"./math_circles_bg.svg": 1360,
	"./math_circles_bg_sm.svg": 1361,
	"./math_courses_1.svg": 1362,
	"./math_courses_2.svg": 1363,
	"./math_road_line_1.svg": 1145,
	"./math_road_line_2.svg": 1146,
	"./math_road_line_3.svg": 1147,
	"./math_road_line_4.svg": 1148,
	"./maths_logo.svg": 1364,
	"./maths_logo_white.svg": 1365,
	"./pc.svg": 1366,
	"./programming_bg.svg": 1294,
	"./programming_bg_sm.svg": 1295,
	"./programming_comment_1.svg": 1133,
	"./programming_comment_2.svg": 1134,
	"./programming_comment_3.svg": 1135,
	"./programming_logo-en.svg": 1127,
	"./programming_logo-ru.svg": 1126,
	"./programming_logo_white.svg": 1125,
	"./programming_puzzles.svg": 1124,
	"./programming_square.svg": 1177,
	"./programming_summer.svg": 1367,
	"./pytpro.svg": 1368,
	"./pytstart.svg": 1369,
	"./school.svg": 1162,
	"./share_icon_violet.svg": 1178,
	"./share_icon_white.svg": 1136,
	"./smile.svg": 1163,
	"./tg_logo.svg": 1112,
	"./tg_logo_white.svg": 1116,
	"./unity.svg": 1370,
	"./videocontent.svg": 1371,
	"./websites.svg": 1372,
	"./whats_logo.svg": 1111,
	"./whats_logo_white.svg": 1115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1349;